import React from 'react';
import '../../../assets/css/edittags.css';
import { useRef } from 'react';
import { useEffect } from 'react';
export default function FormEdit(props) {
  const {
    width,
    title,
    show,
    setShow,
    saveDisabled,
    children
  } = props;
  const hidePopup = (e) => {
    if (e.target.className === 'form-container')
      setShow(false);
  }

  return (
    <>
      {show && (
        <div className='form-container' onClick={(e) => hidePopup(e)}>
          <div className='form-display' style={{ width: width }}>
            <div className='action-title'>{title}</div>
            <div className='form-dataEntry'>
              {children}
            </div>
            <div className='action-container'>
              <button type="button" onClick={()=>setShow(false)} >Cancel</button>
              <button type="button" className='active' disabled={saveDisabled} autoFocus>Save</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
